import { Loader } from "@googlemaps/js-api-loader"
import mapAutocomplete from "./map-autocomplete";

document.addEventListener("DOMContentLoaded", function (event) {
	initMap();

	mapAutocomplete();
	imgScrollEffect();

	// const documentLinks = document.getElementById('contract-links')
	// const documentLinksDropdown = document.getElementById('contractDetailsDropdown');
	// if (documentLinksDropdown) {
	// 	documentLinks.addEventListener('show.bs.dropdown', event => {
	// 		 get_document_data( documentLinks.dataset.id )
	// 	})
	// }
});

const imgScrollEffect = () => {
	let docs = document.documentElement;
	window.addEventListener('scroll', function (e) {
		let img = document.querySelectorAll('.section--home-featured .featured-section');
		let doc = document.documentElement;
		let ch = doc.clientHeight;



		if (img) {
			img.forEach(_i => {

				if ((ch / 2.5) > _i.getBoundingClientRect().top && (ch / 3) < _i.getBoundingClientRect().bottom) {

					_i.classList.add('active');

				} else {

					_i.classList.remove('active');

				}
			}) // endforeach
		}
	});
}

async function initMap() {

	const loader = new Loader({
		apiKey: "AIzaSyA7OpqsOyv1YChC_TxY-oKCvOTBvscJrMw",
		version: "weekly"
	});

	const options = {
		componentRestrictions: {
			country: "au"
		},
		fields: ["address_components", "geometry", "icon", "name"],
		strictBounds: false,
		types: ["address"],
	};

	loader.load().then(async () => {
		const { Autocomplete } = await google.maps.importLibrary("places");

		const autocompleteInputs = document.querySelectorAll('.autocomplete-address input[type="text"]');
		autocompleteInputs.forEach(function (input) {
			new Autocomplete(input, options);
		});
	});

}

/**
 * Prevent the search form from submitting when the search field is focused.
 * Allows users to select from the dropdown without submitting the form.
 */
function propertySearchForm() {

	NiceSelect.bind(
		document.getElementById('property_location'),
		{ searchable: true, placeholder: 'Search' }
	);

	const searchForm = document.getElementById('property-search-form');

	searchForm.addEventListener('submit', function (e) {
		if (searchForm.querySelector('.nice-select-search:focus')) {
			e.preventDefault();
			document.getElementById("PrimarySubmit").focus();
		}
	});
}




export { propertySearchForm }



/**
 *
 * @returns {Promise<void>}
 * @param rexID The listing Rex ID.
 */
window.get_document_data = async (rexID) => {

	const args = {
		method: 'POST',
		body: 'action=get_rex_document_data&listing_id=' + rexID + '&ajax-nonce=' + docs_ajax.nonce,
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
	}
	const response = await fetch(docs_ajax.url, args)
	const docs = await response.json()

	if (docs) {

		const dropdown = document.getElementById('loading-contract')
		let links = '';

		for (const [key, value] of Object.entries(docs)) {

			let doc_title = value.description.split(' -')

			if (doc_title[0].toLowerCase().includes('title')) {
				doc_title[0] = 'Title Search'
			}

			links = links + `
				<a class="dropdown-item px-3" href="${value.url}" target="_blank" rel="noopener">
					${doc_title[0]}
				</a>`
		}
		dropdown.parentElement.innerHTML = links
	}
}